import * as buy from "model/actions/utilities/_buy";
const action = "GET_HORSE";

const notification = () => `a trusty steed`;

const attempt = (price) => {
  const result = {
    success: true,
    cost: {
      coins: -price,
    },
    gain: {
      horse: true,
    },
  };

  return result;
};

const executeSideEffects = (context, result) => {
  const { party } = context;
  const { gain, cost } = result;
  const { history, resources } = party;

  // Track action
  history.add({ action, result }, context);

  // Update resources
  resources.delta({ ...cost, ...gain }, context);
  // TODO horse traits - introduce weight, speed, endurance, etc.

  // notify of the results
  return {
    notification: notification(result),
  };
};

// A horse is bought once, so it has no lot and no count — but it reads the market live for the
// same reason the others do: the button is frozen into the shop event at construction, and a
// captured price would go stale the moment anything moved the market.
const buyHorse = () => ({
  title: "Buy Horse",
  hotkey: "H",
  type: action,
  enabled: (ctx) => {
    const [, price] = buy.adjustQuantityAndCost(ctx, "horse");
    return !ctx.party.resources.items.horse.value &&
      ctx.party.resources.attribs.coins.value >= price;
  },
  execute: (ctx) => {
    const [, price] = buy.adjustQuantityAndCost(ctx, "horse");
    const result = attempt(price);
    const { message, notification } = executeSideEffects(ctx, result);

    return { result: { message }, notification };
  },
  tooltips: (ctx) => [
    ctx.party.resources.items.horse.value
      ? ["already owned"]
      : ["coins", `${buy.adjustQuantityAndCost(ctx, "horse")[1]}`],
  ],
});
export { action as BuyHorseType, buyHorse as default };
